"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _reactRouterDom = require("react-router-dom");
var _helpers = require("./helpers.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var WithPasscode = function WithPasscode(_ref) {
  var passcodeSettings = _ref.passcodeSettings,
    deploymentId = _ref.deploymentId;
  var location = (0, _reactRouterDom.useLocation)();
  var passcodeBackground = passcodeSettings.passcodeBackground,
    passcodeLabel = passcodeSettings.passcodeLabel,
    passcodeBackgroundColor = passcodeSettings.passcodeBackgroundColor,
    passcodeAssistant = passcodeSettings.passcodeAssistant,
    passcodeBackgroundUpload = passcodeSettings.passcodeBackgroundUpload;
  var onHandleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var _response$data, _response$data$data;
      var response, passcodeErr, hash;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentDeploymentRespondent.checkPasscode', {
              deploymentId: deploymentId
            }), {
              passcode: values.passcode
            });
          case 1:
            response = _context.v;
            if (!(response.data.errors || !(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$data = _response$data.data) !== null && _response$data$data !== void 0 && _response$data$data.respondent_hash))) {
              _context.n = 2;
              break;
            }
            passcodeErr = 'Error: Could not verify passcode';
            try {
              passcodeErr = response.data.errors.passcode[0];
            } catch (e) {
              // meh *shrugs*
            }
            return _context.a(2, Promise.reject({
              passcode: passcodeErr
            }));
          case 2:
            hash = response.data.data.respondent_hash;
            window.location = "".concat(Boilerplate.url("".concat(location.pathname, "/").concat(hash)));
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onHandleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var renderAssistant = function renderAssistant() {
    var assistant = passcodeAssistant;
    if (!assistant || !_cccisdLaravelFlow.assistants[assistant]) {
      return null;
    }
    var Component = _cccisdLaravelFlow.assistants[assistant].Side;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].assistant,
      style: {
        top: assistant === 'frankie' ? 'calc(50% - 300px)' : ' calc(50% - 225px)'
      }
    }, /*#__PURE__*/_react["default"].createElement(Component, null));
  };
  var backgroundImage = passcodeBackground;
  var validate = function validate(values) {
    var errors = {};
    if (!values.passcode) {
      errors.passcode = "\"".concat(passcodeLabel, "\" is required.");
    }
    return errors;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].page,
    style: {
      backgroundImage: (0, _helpers.showBackground)(backgroundImage, passcodeBackgroundUpload),
      backgroundColor: passcodeBackground === 'solidColor' ? (0, _helpers.showBackgroundColor)(passcodeBackgroundColor) : ''
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].body
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: onHandleSubmit,
    validate: validate,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].field
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "passcode",
        component: _cccisdFormik.CccisdInput,
        label: passcodeLabel,
        autoFocus: true
      })), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-lg btn-primary",
        type: "submit",
        onClick: handleSubmit
      }, "Start"));
    }
  })), renderAssistant());
};
var _default = exports["default"] = WithPasscode;
WithPasscode.propTypes = {
  passcodeSettings: _propTypes["default"].object,
  deploymentId: _propTypes["default"].number
};